import { en } from './en.js'

export const es = structuredClone(en)
